<template>
  <el-dialog
    :title="title"
    :visible.sync="visibleSync"
    width="800px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    @close="handleClose"
    @opened="handleOpened"
  >
    <el-form :model="form" :rules="rules" ref="form" label-width="100px">
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入图斑名称"></el-input>
      </el-form-item>
      <el-form-item label="野外编号" prop="fieldNo">
        <el-input v-model="form.fieldNo" placeholder="请输入野外编号"></el-input>
      </el-form-item>
      <el-form-item label="面积(㎡)" prop="area">
        <el-input-number v-model="form.area" :min="0" :precision="2" style="width: 200px;"></el-input-number>
      </el-form-item>
      <el-form-item label="描述" prop="description">
        <el-input type="textarea" v-model="form.description" rows="3"></el-input>
      </el-form-item>
      <el-form-item label="省">
        <el-input v-model="currentDistrict.provinceName" disabled></el-input>
      </el-form-item>
      <el-form-item label="市">
        <el-input v-model="currentDistrict.cityName" disabled></el-input>
      </el-form-item>
      <el-form-item label="区县">
        <el-input v-model="currentDistrict.districtName" disabled></el-input>
      </el-form-item>
      <el-form-item label="乡镇/街道" prop="township">
        <el-select v-model="form.township" placeholder="请选择乡镇/街道" style="width: 100%;">
          <el-option v-for="item in townshipList" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="矢量范围">
        <div style="border: 1px solid #dcdfe6; border-radius: 4px; padding: 10px;">
          <div style="height: 300px; position: relative;">
            <swqyun-map
              ref="swqyunMap"
              style="width: 100%; height: 100%;"
              :scene-url="sceneUrl"
              :session-key="sessionKey"
              :app-id="appId"
              :editable="true"
              :draw-type.sync="drawType"
              :vectors="mapVectors"
              scene="spot"
              @draw-complete="onDrawComplete"
              @draw-cleared="onDrawCleared"
            />
          </div>
          <div style="margin-top: 8px; display: flex; align-items: center; gap: 10px;">
            <el-upload
              action=""
              accept=".kml"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="handleKmlChange"
            >
              <el-button size="small" type="primary">导入 KML</el-button>
            </el-upload>
            <span style="color: #909399; font-size: 12px;">提示：点-单击地图；线-两次点击；面-至少三次点击形成闭合区域。绘制完成后会自动保存坐标。</span>
          </div>
        </div>
      </el-form-item>
      <el-divider content-position="left">监测数据（非必填）</el-divider>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="复绿植被成活率(%)">
            <el-input-number v-model="form.vegetationSurvivalRate" :min="0" :max="100" :precision="2" style="width: 100%;"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="复绿植被成活数(株)">
            <el-input-number v-model="form.vegetationSurvivalCount" :min="0" :precision="0" style="width: 100%;"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="土壤质量达标率(%)">
            <el-input-number v-model="form.soilQualityRate" :min="0" :max="100" :precision="2" style="width: 100%;"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="水量质量达标率(%)">
            <el-input-number v-model="form.waterQualityRate" :min="0" :max="100" :precision="2" style="width: 100%;"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="植被覆盖率(%)">
            <el-input-number v-model="form.vegetationCoverage" :min="0" :max="100" :precision="2" style="width: 100%;"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="修复面积(㎡)">
            <el-input-number v-model="form.repairArea" :min="0" :precision="2" style="width: 100%;"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="visibleSync = false">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import SwqyunMap from "@/components/SwqyunMap.vue";
import { CodeToText } from "element-china-area-data";

export default {
  components: { SwqyunMap },
  props: {
    visible: Boolean,
    data: Object
  },
  data() {
    return {
      drawType: null,
      sceneUrl: "",
      sessionKey: "",
      appId: "",
      form: {
        id: null,
        name: "",
        fieldNo: "",
        area: 0,
        description: "",
        township: "",
        vegetationSurvivalRate: null,
        vegetationSurvivalCount: null,
        soilQualityRate: null,
        waterQualityRate: null,
        vegetationCoverage: null,
        repairArea: null,
        vectorGeoJson: ""
      },
      townshipList: [],
      currentDistrict: { provinceName: "", cityName: "", districtName: "" },
      mapVectors: [],
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        fieldNo: [{ required: true, message: "请输入野外编号", trigger: "blur" }]
      }
    };
  },
  computed: {
    visibleSync: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },
    title() {
      return this.form.id ? "编辑图斑" : "新建图斑";
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.loadMapConfig();
        this.initForm();
        this.loadDistrictInfo();
        this.loadTownships();
      }
    }
  },
  methods: {
    loadMapConfig() {
      const districtId = this.$store.state.district && this.$store.state.district.districtInfo && this.$store.state.district.districtInfo.districtId;
      this.$apis.get("/admin/districtMapConfig/detail", { districtId }).then(res => {
        if (res && res.data && res.data.code == 200 && res.data.data) {
          const cfg = res.data.data;
          this.sceneUrl = cfg.sceneUrl;
          this.sessionKey = cfg.sessionKey;
          this.appId = cfg.appId;
        } else {
          this.sceneUrl = "https://api.swqyun.com/api/fileManage/Scene/SDKGetScene?id=138b92545134d878d5d90ca45490263c";
          this.sessionKey = "0271ae43f09e427cb6927d6255446bc0b3cec903f45b48a49fb22dba752f52cb";
          this.appId = "31f37381eb434c2b";
        }
      }).catch(() => {
        this.sceneUrl = "https://api.swqyun.com/api/fileManage/Scene/SDKGetScene?id=138b92545134d878d5d90ca45490263c";
        this.sessionKey = "0271ae43f09e427cb6927d6255446bc0b3cec903f45b48a49fb22dba752f52cb";
        this.appId = "31f37381eb434c2b";
      });
    },
    handleOpened() {
      this.$nextTick(() => {
        [100, 400, 800].forEach(ms => {
          setTimeout(() => {
            if (this.$refs.swqyunMap) {
              this.$refs.swqyunMap.doResize();
            }
          }, ms);
        });
      });
    },
    loadDistrictInfo() {
      // 1. 先拿到 districtId：编辑时用图斑自身的，新建时用当前用户的
      let districtId = this.data && this.data.districtId;
      let provinceId = this.data && this.data.provinceId;
      let cityId = this.data && this.data.cityId;
      let districtName = this.data && this.data.districtName;

      // 新建时 this.data 为 null，从当前用户缓存取
      if (!districtId) {
        let info = this.$store.state.district && this.$store.state.district.districtInfo;
        if (!info || !info.districtId) {
          try {
            const userInfoStr = localStorage.getItem("adminUserInfo");
            if (userInfoStr) info = JSON.parse(userInfoStr);
          } catch (e) { info = null; }
        }
        if (info) {
          districtId = info.districtId;
          provinceId = info.provinceId;
          cityId = info.cityId;
          districtName = info.districtName;
        }
      }

      // 2. 根据 districtId 推断编码（中国行政区划编码规则）
      if (districtId && String(districtId).length === 6) {
        const did = String(districtId);
        if (!provinceId) provinceId = did.substring(0, 2) + "0000";
        if (!cityId) cityId = did.substring(0, 4) + "00";
      }

      // 3. 用 CodeToText 反查中文名称
      this.currentDistrict = {
        provinceName: (provinceId && CodeToText[String(provinceId)]) || "",
        cityName: (cityId && CodeToText[String(cityId)]) || "",
        districtName: (districtId && CodeToText[String(districtId)]) || districtName || ""
      };

      // 4. 兜底：仍缺失时调接口
      if (!this.currentDistrict.provinceName || !this.currentDistrict.cityName || !this.currentDistrict.districtName) {
        this.$apis.get("/admin/backendUser/info").then(res => {
          if (res.data.code == 200 && res.data.data) {
            const user = res.data.data;
            if (user.provinceName) this.currentDistrict.provinceName = user.provinceName;
            if (user.cityName) this.currentDistrict.cityName = user.cityName;
            if (user.districtName) this.currentDistrict.districtName = user.districtName;
          }
        });
      }
    },
    loadTownships() {
      this.$apis.get("/admin/dashboard/township/list").then(res => {
        if (res.data.code == 200) {
          this.townshipList = res.data.data || [];
        }
      });
    },
    handleKmlChange(file) {
      if (!file || !file.raw) return;
      const reader = new FileReader();
      reader.onload = e => {
        try {
          const text = e.target.result;
          const parser = new DOMParser();
          const xml = parser.parseFromString(text, "text/xml");
          const coordinatesTags = xml.getElementsByTagName("coordinates");
          if (!coordinatesTags.length) {
            this.$message.error("KML 文件中未找到坐标数据");
            return;
          }
          let parsed = false;
          for (let i = 0; i < coordinatesTags.length; i++) {
            const tag = coordinatesTags[i];
            const coordText = tag.textContent.trim();
            if (!coordText) continue;

            let parent = tag.parentNode;
            let geomType = "point";
            while (parent && parent.nodeName.toLowerCase() !== "kml" && parent.nodeName.toLowerCase() !== "document") {
              const name = parent.nodeName.toLowerCase();
              if (name === "point") { geomType = "point"; break; }
              if (name === "linestring") { geomType = "line"; break; }
              if (name === "polygon" || name === "outerboundaryis") { geomType = "area"; break; }
              parent = parent.parentNode;
            }

            const tuples = coordText.split(/\s+/).filter(s => s);
            const pointList = [];
            for (const tuple of tuples) {
              const parts = tuple.split(",");
              if (parts.length >= 2) {
                pointList.push({
                  longitude: parts[0].trim(),
                  latitude: parts[1].trim(),
                  height: parts[2] ? parts[2].trim() : "0"
                });
              }
            }

            if (pointList.length > 0) {
              let calcType = geomType;
              if (calcType === "point" && pointList.length > 1) calcType = "line";
              if (pointList.length >= 3 && (geomType === "area" || geomType === "polygon")) calcType = "area";

              const geoJson = { calcType, pointList };
              this.form.vectorGeoJson = JSON.stringify(geoJson);
              this.mapVectors = [geoJson];
              this.drawType = calcType;
              this.$message.success("KML 解析成功，共 " + pointList.length + " 个坐标点");
              parsed = true;
              break;
            }
          }
          if (!parsed) {
            this.$message.error("KML 坐标解析失败");
          }
        } catch (err) {
          console.error("KML parse error", err);
          this.$message.error("KML 解析异常");
        }
      };
      reader.readAsText(file.raw);
    },
    initForm() {
      if (this.data) {
        this.form = {
          id: this.data.id,
          name: this.data.name,
          fieldNo: this.data.fieldNo,
          area: this.data.area || 0,
          description: this.data.description || "",
          township: this.data.township || "",
          vegetationSurvivalRate: this.data.vegetationSurvivalRate != null ? Number(this.data.vegetationSurvivalRate) : null,
          vegetationSurvivalCount: this.data.vegetationSurvivalCount != null ? Number(this.data.vegetationSurvivalCount) : null,
          soilQualityRate: this.data.soilQualityRate != null ? Number(this.data.soilQualityRate) : null,
          waterQualityRate: this.data.waterQualityRate != null ? Number(this.data.waterQualityRate) : null,
          vegetationCoverage: this.data.vegetationCoverage != null ? Number(this.data.vegetationCoverage) : null,
          repairArea: this.data.repairArea != null ? Number(this.data.repairArea) : null,
          vectorGeoJson: this.data.vectorGeoJson || ""
        };
      } else {
        this.form = {
          id: null,
          name: "",
          fieldNo: "",
          area: 0,
          description: "",
          township: "",
          vegetationSurvivalRate: null,
          vegetationSurvivalCount: null,
          soilQualityRate: null,
          waterQualityRate: null,
          vegetationCoverage: null,
          repairArea: null,
          vectorGeoJson: ""
        };
      }
      // 解析已有矢量数据用于地图显示，但 drawType 始终设为 null，
      // 让"点/线/面"按钮默认都不选中，只有用户点击后才选中
      this.drawType = null;
      if (this.form.vectorGeoJson) {
        try {
          let parsed = JSON.parse(this.form.vectorGeoJson);
          // 兼容旧格式：单个对象包装为数组
          if (parsed && !Array.isArray(parsed)) {
            parsed = [parsed];
          }
          this.mapVectors = parsed || [];
        } catch (e) {
          this.mapVectors = [];
        }
      } else {
        this.mapVectors = [];
      }
    },
    onDrawComplete(e) {
      this.form.vectorGeoJson = JSON.stringify(e);
      this.mapVectors = e ? [e] : [];
    },
    onDrawCleared() {
      this.form.vectorGeoJson = "";
      this.mapVectors = [];
      this.drawType = null;
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.$apis.post("/admin/spot/saveOrUpdate", this.form).then(res => {
          if (res.data.code == 200) {
            this.$message.success("保存成功");
            this.visibleSync = false;
            this.$emit("success");
          } else {
            this.$message.error(res.data.msg || "保存失败");
          }
        });
      });
    },
    handleClose() {
      this.$refs.form.resetFields();
      if (this.$refs.swqyunMap) {
        this.$refs.swqyunMap.clearDraw();
      }
      this.mapVectors = [];
      this.drawType = null;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/components/addOrEditSpot.vue